import CreditCard from './CreditCard.vue'

export default {
    install(Vue, options) {
        Vue.component('credit-card', CreditCard)
    }
}
